import * as React from "react";

import {
  SingleLineTextInput,
  SingleLineTextInputProps,
} from "./single-line-text-input";

interface PasswordWithVisibilityToggleInputProps
  extends SingleLineTextInputProps {}

export const PasswordWithVisibilityToggleInput: React.FunctionComponent<
  PasswordWithVisibilityToggleInputProps
> = (props) => {
  const [isPlainTextVisibile, setIsPlainTextVisible] = React.useState(false);
  const onVisibilityToggleClicked: React.MouseEventHandler<
    HTMLButtonElement
  > = (event) => {
    event.preventDefault();
    setIsPlainTextVisible(!isPlainTextVisibile);
  };
  return (
    <SingleLineTextInput
      {...props}
      className={`password-with-visibility-toggle-input ${
        isPlainTextVisibile ? "plain-text-visible" : "obfuscated-password"
      }`}
      type={isPlainTextVisibile ? "text" : "password"}
    >
      <button
        type="button"
        className="visibility-toggle"
        onClick={onVisibilityToggleClicked}
      />
    </SingleLineTextInput>
  );
};
